import React, { useEffect, useState } from "react";
import {
  Form,
  InputContainer,
  ButtonsContainer,
  Button,
  ErrorSpan,
} from "./DepositElements";
import { useTranslation } from "react-i18next";
import { formatNumber, toLocale, toLocaleString } from "../../utils/tools";
import { useSelector } from "react-redux";
import { selectCurrency } from "../../features/user/userSlice";
import { selectLimites } from "../../features/limitaciones/limitacionesSlice";

const FormSafetyPay = ({
  form,
  handleChange,
  handleClose,
  handleSubmit,
  loading,
}) => {
  const [t] = useTranslation("global");
  const moneda = useSelector(selectCurrency);
  const [monto, setMonto] = useState(0);
  const [blur, setBlur] = useState(false);  

  const limitaciones = useSelector(selectLimites);
  const [montoMinimo, setMontoMinimo] = useState(10)
  const [montoMaximo, setMontoMaximo] = useState(0)

  useEffect(()=>{
    if(limitaciones.minimo_deposito>0 && limitaciones.minimo_deposito>montoMinimo) setMontoMinimo(limitaciones.minimo_deposito)

    if(limitaciones.maximo_deposito>0) setMontoMaximo(limitaciones.maximo_deposito)
  },[limitaciones])

  const handleMonto = (e) => {
    setBlur(true);
    handleChange(formatNumber(e));
    setMonto(parseFloat(e.target.value.replaceAll('.', '').replace(',', '.')));
    if(e.target.value==='') setMonto(0);
  }

  return (
    <Form>
      <InputContainer>
        <label>EMAIL:</label>
        <input
          type="email"
          placeholder="EMAIL"
          name="email"
          value={form.email}
          onChange={handleChange}
        />
      </InputContainer>

      <InputContainer>
          <label>{t('deposit.lbl-amount')}</label>
          <input type='text' placeholder='0,00' name='monto1' value={form.monto1} onChange={(e)=>handleMonto(e)}/>
          

          {monto < montoMinimo && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} {toLocaleString(montoMinimo)} {moneda}{" "}
          </ErrorSpan>
        )}
        {montoMaximo > 0 && monto > montoMaximo && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} {toLocaleString(montoMaximo)} {moneda}{" "}
          </ErrorSpan>
        )}
        
        </InputContainer>

      <ButtonsContainer>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          {t("deposit.btn-cancel")}
        </Button>
        <Button primary={true} disabled={(loading||monto<montoMinimo || (montoMaximo>0 ? monto>montoMaximo : false))} onClick={handleSubmit}>
          {loading ? "CARGANDO..." : t("deposit.btn-confirm")}
        </Button>
      </ButtonsContainer>
    </Form>
  );
};

export default FormSafetyPay;
